export const API_ENDPOINTS = {
    //#region Auth
    LOGIN: '/Auth/Login',
    TWO_FACTOR_LOGIN: '/Auth/TwoFactorLogin',
    REGISTER_CUSTOMER: '/Auth/RegisterCustomer',
    FORGOT_PASSWORD: '/Auth/ForgotPassword',
    RESET_PASSWORD: '/Auth/ResetPassword',
    //#endregion

    //#region Profile
    GET_PROFILE: '/Customer/GetCustomerContactByCustomerIdAndContactId',
    UPDATE_PROFILE: '/Customer/UpdateCustomerContact',
    CHANGE_PASSWORD: '/Customer/ChangePassword',
    GET_CUSTOMER: '/Customer/GetCustomerById',
    //#endregion

    //#region Order
    GET_ORDER_HISTORY: '/Order/GetOrderHistory',
    GET_ORDER_BY_ID: '/Order/GetOrderById?orderId=',
    GET_LAST_COST_OF_ITEM: '/Order/GetLastCostOfItem?itemId=',
    CREATE_ORDER: '/Order/AddOrder',
    UPDATE_ORDER: '/Order/UpdateOrder',
    //#endregion    

    //#region Item Category
    GET_ITEM_CATEGORY: '/ItemCategory/GetItemCategoryList',
    //#endregion

    //#region Payment
    GET_PAYMENT_HISTORY: '/Payment/GetPaymentHistory',
    GET_SAVED_CARDS: '/Payment/GetSavedCards?connectedAccountId=',
    CREATE_CHECKOUT: '/Payment/ProcessPayment',
    CANCEL_PAYMENT: '/Payment/CancelPayment?request=',
    GET_PAYMENT_STATUS: '/Payment/GetPaymentStatus?sessionId=',
    ADD_CARD: '/Payment/AddCard',
    DELETE_CARD: '/Payment/DeleteCard',
    SET_DEFAULT_CARD: '/Payment/SetDefaultCard',
    //#endregion 

    //#region Item
    GET_PARENT_ITEM: '/Item/GetItemListByCategoryId?categoryId=',
    GET_CHILD_ITEM: '/Item/GetChildItemListByCategoryId?categoryId=',
    GET_PARENT_ITEM_DATA: '/Item/GetParentItemById?id=',
    GET_CHILD_ITEM_DATA: '/Item/GetChildItemById?id=',
    //#endregion 

    //#region Tax
    GET_TAX_BY_ITEM_ID: '/Tax/GetTaxByItemId?id=',
    //#endregion 

    //#region Report
    PRINT_STATEMENT: '/Reports/GetOrderReport',
    //#endregion 

    //#region Notification
    GET_NOTIFICATION_BY_ID: '/Notification/GetNotificationById',
    UPDATE_NOTIFICATION: '/Notification/UpdateNotification?notificationId=',
    //#endregion

    //#region Branding
    GET_BRANDING: '/Branding/GetBranding',
    CREATE_BRANDING: '/Branding/CreateBranding',
    UPDATE_BRANDING: '/Branding/UpdateBranding',
    //#endregion

    //#region Chat
    GET_CHAT: '/Chat/GetChat',
    CREATE_CHAT: '/Chat/CreateChat',
    UPDATE_CHAT: '/Chat/UpdateChat',
    //#endregion
};


